import { Component } from "@angular/core"

@Component({
  selector: "loading-page",
  templateUrl: "index.html",
})
export class LoadingPage {}



// WEBPACK FOOTER //
// ./src/pages/loading/index.ts